"use strict";


// APP Configuration
var conf_guidEmpty = '00000000-0000-0000-0000-000000000000';
var conf_guidF = "FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF";

var sek = 1000;
// Intervallsettings
var conf_intervallDelay = 20 * sek;
var conf_intervallLearnMode = 3 * sek;
// Intervall for fetching Well Known Datapoints (isPresent)
var conf_intervall_wellknowndatapoints = 10 * sek;
// Intervall for fetching current alarms
var conf_intervall_currentalarms = 30 * sek;
// Intervall delay for fetching values (refresh service)
var conf_intervall_valuerefresh = 9 * sek;
// Intervall delay for updateing Sceneview (much data)
var conf_intervall_scenes = 15 * sek;
// Intervall delay for updateing Favorite Values (Homescreen)
var conf_intervall_favoritevaluerefresh = 15 * sek;
// Intervall delay for update AccessRequestCount
var conf_intervall_accessrequests = 120 * sek;


// Default Parent MenuEntry Id when learning a new Device
var conf_NewDeviceParentMenuEntryId = '00000000-0000-0000-0000-000000000000';

// Space between Timeentrys. If less than.. it will unite both
var conf_minMinutesBetweenTimeEntrys = 10;
var conf_minTimeEntryMin = 30;

// Steps in Minutes
var conf_timelineStep = 5;
//

// STATISTIC | Color of graphs
var conf_graph_colors = [

    'rgba(168,203,47,1)',
    'rgba(0,140,240,1)',
    'rgba(250,150,50,1)'
];




 var touchStart = window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart";
 var touchMove = window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove";
 var touchEnd = window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend";
/**/

// appMode => 'debug';
// d() function will be printed to console
// Otherwise it is muted
var conf_appMode = 'debug';



// Well Known Vars
var conf_wellKnownObjects = {


    "DeviceBattery": {
        "DatapointConfigId": "49fa9f10-c988-4782-b970-0a3daf13df5f"
    },
    "Solltemperatur": {
        "DatapointConfigId": "96e92aa1-814c-4fc0-82e7-ad2a7f69ac6a"
    },
    "Isttemperatur": {
        "DatapointConfigId": "777c1a8e-ec1c-4a15-9bcc-4ec5b8e0e4f4"
    },

    "HeatingCurve1": "3f89c8ba-bc2e-4889-bd73-daba9afc164c",
    "HeatingCurve2": "fcc76bd9-2644-4abe-a8cc-74e4e3193b1b",
    "HeatingCurve3": "49a9bab4-5fae-4cc3-9360-c46857617d78",

    "CoolingCurve1": "b8555de8-2a45-4d7a-bbf4-005104c8c798",
    "CoolingCurve2": "7da3c004-b053-4e37-9f4d-302e5741edbe",
    "CoolingCurve3": "10c7fd2e-c3a2-4c2b-b02e-bfbd490b374b",

    "Scenes": {
        '00000000-0000-0000-0000-000000000002': {
            'DisplayName': 'BeiAbwesenheit',
            'Priority': 2147482650,
            'SceneId': "00000000-0000-0000-0000-000000000002"
        },
        '00000000-0000-0000-0000-000000000001': {
            'DisplayName': 'Grundeinstellung',
            'Priority': 0,
            'SceneId': "00000000-0000-0000-0000-000000000001"
        },
        'b37a5d92-eb09-4e9f-a31a-080a118b46ae': {
            'DisplayName': 'Heizen Normal',
            'Priority': 1,
            'SceneId': "b37a5d92-eb09-4e9f-a31a-080a118b46ae"
        },
        '5f59bb7c-1e7b-4540-88f0-94273fa3c284': {
            'DisplayName': 'Trinkwassererwärmung',
            'Priority': 2,
            'SceneId': "5f59bb7c-1e7b-4540-88f0-94273fa3c284"
        }
    },
    "Favorites": {
        '00000000-0000-0000-0000-000000000002': {"DisplayName": 'DeviceManagement', "Position": 1},
        '00000000-0000-0000-0000-000000000003': {"DisplayName": 'RoomManagement', "Position": 2},
        '00000000-0000-0000-0000-000000000005': {"DisplayName": 'Scenes', "Position": 3},
        '00000000-0000-0000-0000-000000000006': {"DisplayName": 'Favorites', "Position": 4}
        //'00000000-0000-0000-0000-000000000004' : {"DisplayName":'Statistik',"Position":5}
    }
};

// Menuentries, Devices etc.
var showHead = false;

// var conf_pickerClasses = {
//
//     // The element states
//     input: 'picker__input',
//     active: 'picker__input--active',
//
//     // The root picker and states *
//     picker: 'picker',
//     opened: 'picker--opened',
//     focused: 'picker--focused',
//
//     // The picker holder
//     holder: 'picker__holder',
//
//     // The picker frame, wrapper, and box
//     frame: 'picker__frame',
//     wrap: 'picker__wrap',
//     box: 'picker__box',
//
//     // The picker header
//     header: 'picker__header',
//
//     // Month navigation
//     navPrev: 'picker__nav--prev icon-pfeil-links',
//     navNext: 'picker__nav--next icon-pfeil-rechts',
//     navDisabled: 'picker__nav--disabled',
//
//     // Month & year labels
//     month: 'picker__month',
//     year: 'picker__year',
//
//     // Month & year dropdowns
//     selectMonth: 'picker__select--month',
//     selectYear: 'picker__select--year',
//
//     // Table of dates
//     table: 'picker__table',
//
//     // Weekday labels
//     weekdays: 'picker__weekday',
//
//     // Day states
//     day: 'picker__day',
//     disabled: 'picker__day--disabled',
//     selected: 'picker__day--selected',
//     highlighted: 'picker__day--highlighted',
//     now: 'picker__day--today',
//     infocus: 'picker__day--infocus',
//     outfocus: 'picker__day--outfocus',
//
//     // The picker footer
//     footer: 'picker__footer',
//
//     // Today, clear, & close buttons
//     buttonClear: 'picker__button--clear',
//     buttonClose: 'picker__button--close icon-loeschen-abbrechen',
//     buttonToday: 'picker__button--today'
// };

var i, l, leftChain, rightChain;
/* Deep comparison code based on SO answer 'Object comparison in JavaScript'.
   See https://stackoverflow.com/a/1144249 */
var deepCompare = function(objectsArr) {


  function compare2Objects (x, y) {
    var p;

    if (typeof x === 'symbol' && typeof y === 'symbol') {
        return x === y;
    }

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
         return true;
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
        return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if ((typeof x === 'function' && typeof y === 'function')
       || (x instanceof Date && y instanceof Date)
       || (x instanceof RegExp && y instanceof RegExp)
       || (x instanceof String && y instanceof String)
       || (x instanceof Number && y instanceof Number)) {
        return x.toString() === y.toString();
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
        return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
        return false;
    }

    if (x.constructor !== y.constructor) {
        return false;
    }

    if (x.prototype !== y.prototype) {
        return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
         return false;
    }

    // Quick checking of one object being a subset of another.
    // todo: cache the structure of arguments[0] for performance
    for (p in y) {
        if (p.lastIndexOf('$', 0) === 0) {
            continue;
        }
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        }
        else if (typeof y[p] !== typeof x[p]) {
            return false;
        }
    }

    for (p in x) {
        if (p.lastIndexOf('$', 0) === 0) {
            continue;
        }
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        }
        else if (typeof y[p] !== typeof x[p]) {
            return false;
        }

        switch (typeof (x[p])) {
            case 'object':
            case 'function':

                leftChain.push(x);
                rightChain.push(y);

                if (!compare2Objects (x[p], y[p])) {
                    return false;
                }

                leftChain.pop();
                rightChain.pop();
                break;

            default:
                if (x[p] !== y[p]) {
                    return false;
                }
                break;
        }
    }

    return true;
  }

  if (objectsArr.length < 1) {
    return true;
    // throw "Need two or more arguments to compare";
  }

  for (i = 1, l = objectsArr.length; i < l; i++) {

      leftChain = [];
      rightChain = [];

      if (!compare2Objects(objectsArr[0], objectsArr[i])) {
          return false;
      }
  }

  return true;
};

angular.module('app.configuration', [
    'app.configuration.enum',
    'app.configuration.icons'
]).//

// TODO: appConfing not as function in app.js
constant('appConfig', function () {
    //var isLocal = true;
    // For Development, filled by gulp
    // Hosts where the app should call api against remote.kermi.de:81
    var remoteHosts = [];
    var isLocal = false;
    //var destinationId = '00000000-0000-0000-0000-000000000000';
    var destinationId;
    var api_host = '';
    var api_server = '';
    var logoutURL;
    var routeTo = 'main';

    if (remoteConfig == undefined) {

        destinationId = '00000000-0000-0000-0000-000000000000';
        api_host = '/api/';
        logoutURL = '#/login';
        api_server = '';
        isLocal = true;

        if (remoteHosts.indexOf(window.location.hostname) >= 0) {
            api_server = '';
            api_host = api_server + '/api/';
        }
    } else {
        destinationId = remoteConfig.destinationId;
        api_host = remoteConfig.api_host;
        logoutURL = remoteConfig.logoutURL;
        api_server = remoteConfig.api_server;
        if( remoteConfig.routeTo ){ routeTo = remoteConfig.routeTo; };
    }

    var loginAPIURL = api_host + 'Security/Login';
    var logoutAPIURL = api_host + 'Security/Logout';
    var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    var touchStart = ( window.navigator.msPointerEnabled ? "pointerdown MSPointerDown" : (supportsTouch ? "touchstart" : "mousedown"));
    var touchMove = ( window.navigator.msPointerEnabled ? "pointermove MSPointerMove" : (supportsTouch ? "touchmove" : "mousemove"));
    var touchEnd = ( window.navigator.msPointerEnabled ? "pointerup MSPointerUp" : (supportsTouch ? "touchend" : "mouseup"));
    var transformTouchToMouse;
    transformTouchToMouse = function (e, fn) {

        var b = e.touches ? e.touches : [{clientX: e.clientX, clientY: e.clientY}];
        var o = {touches: b, originalEvent: e};
        return fn ? fn(o) : o;
    }

    return {
        touch: transformTouchToMouse,
        isTouch: supportsTouch,
        isLocal: isLocal,
        destinationId: destinationId,
        api_host: api_host,
        api_server: api_server,
        logoutURL: logoutURL,
        loginAPIURL: api_host + 'Security/Login',
        logoutAPIURL: api_host + 'Security/Logout',
        touchStart: touchStart,
        touchMove: touchMove,
        touchEnd: touchEnd,
        routeTo : routeTo
    }
}).

constant('conf_guidEmpty', '00000000-0000-0000-0000-000000000000').//

//constant('customActions', _CustomActions).//
// Intervallsettings
constant('conf_intervallDelay', 20 * sek).//
constant('conf_intervallLearnMode', 3 * sek).//
// Intervall for fetching Well Known Datapoints (isPresent)
constant('conf_intervall_wellknowndatapoints', 10 * sek).//
// Intervall for fetching current alarms
constant('conf_intervall_currentalarms', 30 * sek).//
// Intervall delay for fetching values (refresh service)
constant('conf_intervall_valuerefresh', 9 * sek).//
// Intervall delay for updateing Sceneview (much data)
constant('conf_intervall_scenes', 15 * sek).//
// Intervall delay for updateing Favorite Values (Homescreen)
constant('conf_intervall_favoritevaluerefresh', 15 * sek).//
// Intervall delay for update AccessRequestCount
constant('conf_intervall_accessrequests', 120 * sek).//

constant('conf_userlevel', {
    "UserAccess": 10,
    "ExpertAccess": 20,
    "Manufacturer": 30,
    "AdminAccess": 40,
    "SystemAccess": 99
}).//


constant('xCenterConfig', {
    version : {
         app : '2.0.62'
    },
    interval: {
        datapointValues: 9 * sek, // DatapointValues in Datapointlist (inside of a Device)
        homescreenFavoriteValues: 9 * sek, // Homescreen Values of Favorites
        devicecontrolVizualisationDatapointValues: 9 * sek,  // Vizualisation Datapoints in DeviceControl
        roomOverviewValues : 9 * sek,  // Room overview Datapoints
        softwareUpdateCheck: 30 * 60 * sek, // Check for a new Software Update?
        activeAlarmCheck: 300 * sek, // Check for new active Alarms
        accessRequestCheck: 60 * sek, // Check for new access requests
        learnModeState: 2* sek,
        scenes : 15 * sek
    },
    statistic :{
        // Statistic
        // 0.2 => 20 percent white space on top and bottom of graph
        delta_percent : 0.20
    },
    import : {
        /* 20 MB */
        max_file_upload_size: 20
    },
    var : {
        guid_Empty : '00000000-0000-0000-0000-000000000000',
        guid_All : "FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF"
    },
    timeprogram : {
        minMinutesBetweenTimeEntrys :10,
        minTimeEntryMin : 30,
        createTimeEntryMin : 60,
        timelineStep : 5,
        defaultEntryTimeFormat : 'YYYY-MM-DDTHH:mm:ss'
    },
    wellKnownDatapoints : {
        outsideTemperature: "777c1a8e-ec1c-4a15-9bcc-4ec5b8e0e4f4"
    },
    wellKnownDatapointsByDeviceType : {
        // xnet RBG
        5 : [
            // IstTemperatur
            "777c1a8e-ec1c-4a15-9bcc-4ec5b8e0e4f4",
            // SollTemperatur
            "96e92aa1-814c-4fc0-82e7-ad2a7f69ac6a"
            ],
        // x-change dynamic
        2 : [
            // Isttemp TWE
            "83a34595-924a-421e-b9c1-44c2a49f97ad",
            // Status gesamtanlage
            "41258683-9b38-4065-80d2-34c9a7e6ec2c"
        ],
        // xwell-s
        40 : [
            // Lüfterstufe
            "e09ac1f4-ef7e-4cb6-9312-78080b52630f",
            // Relative humidity
            "5938d306-ceef-4aca-93dc-495d2763d32e"
        ],

    },
    // Object for implemented Custom Actions
    customActions : {
        "AccessRequest": {active: true, state: 'access'},
        "CurrentAlarms": {active: true, state: 'alarm-active'},
        "Alarmhistory": {active: true, state: 'alarm-history'},
        "Login": {active: true, modal: 'userLevelLogin'},
        "Favorites": {active: true, state: 'favorites'},
        "FavoriteOverview": {active: true, state: 'favorites'},
        "RoomManagement": {active: true, state: 'rooms.default'},
        "EditScenes": {active: true, state: 'scenes'},
        "Scanner": {active: true, state: 'devices.view'},
        "Statistics": {active: true, state: 'statistic'},
        "DevicesManagementWithFilter": {active: true, state: 'devices.view'},
        "DeviceManagement": {active: true, state: 'devices.view'},
        "HeatingCurve1": {active: true, state: 'device.heatingcurve', stateParams: {heatingCurve: 1,withHeadDevice:true, configData: {EntryId: '21ebf975-f8fc-4fa9-ad87-76df3b343e79'}}},
        "HeatingCurve2": {active: true, state: 'device.heatingcurve', stateParams: {heatingCurve: 2,withHeadDevice:true, configData: {EntryId: 'bf993cc6-9d5d-4c75-8815-d148793ccf80'}}},
        "HeatingCurve3": {active: true, state: 'device.heatingcurve', stateParams: {heatingCurve: 3,withHeadDevice:true, configData: {EntryId: '34a08627-59b6-46d1-8d7b-b501d2c36223'}}},
        "CoolingCurve1": {active: true, state: 'device.coolingcurve', stateParams: {coolingCurve: 1,withHeadDevice:true, configData: {EntryId: 'bf3a0b22-c6e4-448c-84a8-b1b4aedb52e2'}}},
        "CoolingCurve2": {active: true, state: 'device.coolingcurve', stateParams: {coolingCurve: 2,withHeadDevice:true, configData: {EntryId: '932df8dc-49e1-4fd7-9802-831ee14904c7'}}},
        "CoolingCurve3": {active: true, state: 'device.coolingcurve', stateParams: {coolingCurve: 3,withHeadDevice:true, configData: {EntryId: '9b2bcbaa-0100-43a4-bd35-7b0e19481136'}}},
        "FunctionHeating": {active: true, state: 'device.functionheating.default', stateParams: { withHeadDevice:true }},
        "FunctionHeatingCurve": {active: true, state: 'device.functionheating.curve', stateParams: { withHeadDevice:true }},
        "OverviewBattery": { active: true, state: 'device.overviewbattery' },
        //"Scanner" : false,
        "ChangeLanguage" : {active: true}, // implemented as an angular broadcast,
        "ControlLogicSettings": {active: true, state: 'controllogicsettings.default'},
        "OverviewHeatingCircuit": { active: true, state: 'overviewheatingcircuit.default', stateParams: { withHeadDevice:true }},
        "OverviewCoolingCircuit": { active: true, state: 'overviewcoolingcircuit.default', stateParams: { withHeadDevice:true }},
        "Backup": { active: true, state: 'system.settings.backuprestore' },
        "OverviewVentilation": { active: true, state: 'overviewventilation.default', stateParams: { withHeadDevice:true }},
        "ImportExportScenes": { active: true, state: 'scenes.importexport.choice' },
        "ProtocolManagement": { active: true, state: 'protocolprovider.view' },
        "Location": { active: true, state: 'system.settings.location.default' },
        "ActiveManualValues": { active: true, state: 'device.activeManualValues.default' },
        "DeviceOptions": { active: true, state: 'device.entry.customDeviceOptions.default' },

        /* AccessControlListUsers */
        "Acl": { active: true, state: 'system.settings.users.accessControlList' },
        "AccessControlListDevice": { active: true, state: 'device.accessControlList' },
        "AccessControlListScene": { active: true, state: 'scene.accessControlList' },
        "AccessControlListUserDetail": { active: true, state: 'user.accessControlList' }
    },

    deviceOptions: {
        "Heatpump_MK1": "4D677B5C-B24B-48fb-A9AD-F7FC8D5E2962",
        "Heatpump_MK2": "BA9B7040-42F5-4a7b-AE6E-ECC3CA3E3F02",
        "Heatpump_MK3": "870FB1CA-8E8B-47ca-9A34-045DC61EF60A",
        "EMeter_Producer": "4ca66e2a-f249-4d84-af51-5ea415fe21b1",
        "EMeter_Battery": "e0eacb46-f89e-40cb-8bae-362266de5285",
        "EMeter_NAP": "810ce170-929f-429f-a5c4-9fd116890901"
    },
    datapointsFloat: {
        "HP_AktuelleMotorleistungKW": "3576624b-1af4-4406-8e8b-12500acd4840",
        "HP_FanAktuelleLeistung": "7605e769-5bcf-4e37-97e4-e1cded35dc54",
        "HP_TotalCOP": "34760a09-8f79-424f-a1b0-5f1a9339d864",
        "Aussentemperatur_gemittelt": "7b712484-4c0e-4b8d-9425-25f9f7072777",

        "HP_MK1IstTemp": "4e53d1c7-f461-4e00-ad71-2e0375be8e0c",
        "HP_MK1SollTempPanel": "c068737a-aca4-4084-88d9-44cfe9b72a4c",

        "HP_MK2IstTemp": "cf6fda09-6e9d-4477-b643-4839c4cc646f",
        "HP_MK2SollTempPanel": "2b11b9f9-60e5-4402-bd32-7802c31cd1e4",
        "HP_AuslasstempLadekreis": "6576ccc5-048a-482e-ac0d-ef4dc0de16c4",
        "HP_EinlasstempLadekreis": "6ca1372b-894d-4f27-add3-257fff9905c1",
        "HP_RegelsignalPufferladepumpe": "f3eda5be-7108-43c3-b978-0acbdc5bf20a",
        "HP_Link_RegelsignalPufferladepumpe": "80f0303e-dea9-41f7-aadf-a33bc97e2917",
        "HP_NeutralzoneLadepumpe": "2fb0c234-ef86-43fe-9b68-18802f48f6ce",

        "HP_TWETempIst": "83a34595-924a-421e-b9c1-44c2a49f97ad",
        "HP_EinschalthystereseTWE": "0e49c014-982a-47b9-821e-c4f09866e351",
        "HP_Link_EinschalthystereseTWE": "4f22611c-8902-4bd9-8e27-cea718c9c656",
        "HP_EinschalthystereseHW": "19e54d45-4920-4621-bb15-e2d1ee614b7a",
        "HP_Link_EinschalthystereseHz": "dede9d08-04d0-4cb3-be99-6c7081843f3c",
        "HP_IstTempHW": "fc1c59db-33d8-41f4-afb9-0513d18e8095",
        "HP_HeizwasserSollwertPanel": "985cce22-e260-461f-bc25-44b72a13b8f3",
        "HP_Link_AktuellerPuffersollwert": "c8797976-59ee-45f3-856a-5aec3693736c",

        "HP_AktuelleSollspreizungPufferladekreis": "9bdf9d62-072c-440c-807a-793e845d3dd3",
        "HP_Link_AktuelleSollspreizungPufferladekreis": "0bdc904c-e2a8-47b1-9943-8e029d83347c",
        "HPxyz_DurchflussIstLadekreis": "01860ced-3dd2-4ab2-9cd8-da0e7cde597e",
        "HP_TWESoll": "ca4dd370-2cd7-4a6b-b091-f9df74150265",

        "HP_MK3SollTempPanel": "0602a0e5-88f4-4756-802d-cae0164675eb",
        "HP_TWESollEinmal": "83049eb3-7f02-4032-98e4-7b39dfc9252d",

        "HP_EinlasstempGeokreis": "88696e86-50ce-4bb6-bb9d-8e6d4ae814f8",
        "HP_AuslasstempGeokreis": "b7b3f408-c605-4209-b993-02e002503f10",

        "HP_S1Saugdruck": "57997d59-2d15-4181-93aa-b204602552f6",
        "HP_S1SaugTemperatur": "c772c940-c2b9-450e-944c-b17d669f609c",
        "HP_S3Hochdruck": "4defbd2c-200a-45d8-b66c-4c4a71a53a95",
        "HP_S4HeissgasendTemperatur": "74cebfa2-e5cb-46e6-b7ed-94c9956ef199",

        "HP_RegelsignalLuefter": "27ff9d9c-4158-47fb-9e74-f37f000ad3d1",
        "HP_TT14Öltemperatur": "1a1447c4-e69b-4486-86da-44be09401022",
        "HP_AktuelleÜberhitzung": "63e680f8-954d-47f5-825c-6e57bf07cff0",
        "HP_SollwertÜberhitzung": "691ee49a-45fe-4942-85bf-5ee784f212a4",
        "HP_AktuellerDiffernzdruck": "91870abd-448e-4081-99ad-dde385e7d45d",
        "HP_AktuelleVerdampfungsTemperatur": "93ba8f0a-e5fe-47f9-b64e-004e4983fca6",
        "HP_VerdichterRotorGeschwindigkeitIst": "348c24b9-7f3c-4d50-ac05-ab7b2f5dc4a2",

        "Aussentemperatur": "777c1a8e-ec1c-4a15-9bcc-4ec5b8e0e4f4",
        "KWL_ZulufttemperaturT2": "a4f0af8c-cb12-443e-9ffd-dcf185c99502",
        "KWL_AblufttemperaturT3": "50bbca4e-6993-42cc-8bc0-1c46033e7056",
        "KWL_FortlufttemperaturT4": "d3f6357b-934f-4f32-8ab2-449985953d97",
        "KWL_Auslastung_Ventilator_1": "90b8b9f1-94cd-4fa8-9d83-75c4b15d3660",
        "KWL_Auslastung_Ventilator_2": "5069b498-aeeb-4e3d-9329-52207812d64a",
        "KWL_Relative_Luftfeuchtigkeit": "5938d306-ceef-4aca-93dc-495d2763d32e",
        "KWL_F130_Relative_Luftfeuchtigkeit": "95d3ab12-107c-4c10-80bc-c66483dceed8",

        "CoolingSetpointTemperatureBuffer": "2bf05a2f-f8bd-4a3f-87ef-2ec3bc8f1484",
        "HP_Link_SolltemperaturKühlen": "bb96f9c6-5ecb-420f-a0d4-338baa244a68",
        "CoolingActualTemperatureBuffer": "22a76cf4-cbf2-4727-9c94-7e6bc6827ab8",
        "HP_EinschalthystereseKuehlen": "6e2605f8-bf1a-4cca-9492-ffe88ccd1a9f",
        "HP_Link_EinschalthystereseKuehlen": "4f5302a6-515e-45ad-a860-06f02f0aba50",

        "HP_RegelsignalSolePumpe": "3836e1bb-f583-4575-ba6c-a542216af585",
        "HP_DurchflussSoleKreis": "6a7c2b23-341f-49f1-b3cb-49b99d51f266",

        "HP_GrundwasserWaermetauscherEintrittstemperatur": "b58e0b0b-1df1-4298-84d6-72da6c4b9b8b",
        "HP_GrundwasserWaermetauscherAustrittstemperatur": "1025d993-5026-4141-baaf-dd3def001f4d",
        "HP_PassivesKuehlenEintrittstemperatur": "66424060-f5a8-49a8-8196-48a0c6671655",

        "HP_AktuelleKondensationstemperatur": "daf3dada-90be-4441-85b7-5a96a17a0606",

        "Battery_Erzeugung": "aef64715-1d6b-4288-b91b-6e075e717e73",
        "Battery_Netzbezug_Netzeinspeisung": "fd6f5644-3de9-4bce-9ef3-f455d712c4d7",
        "Battery_Speicher_Entladung_Beladung": "3ced0490-bf7e-48dc-9c3c-6198487bd36d",
        "Battery_Verbrauch": "d248ac20-8f0e-4198-b909-adc9bb3c1de8",

        "Aktueller_Sollwert_DSH": "152c09b0-9508-45fd-834f-216424b4ac76",
        "Aktuelle_DSH-Überhitzung": "734e3d64-daf9-4a9b-86e7-34f6dd0ce8e8",
        "Aktueller_Sollwert_DLT": "8281a711-ab48-4ddb-acae-38d74f3bcf33",

        "EMeter_CurrentPowerTotal": "d4663186-18bc-40ff-8b23-2a668574faba",
        "Battery_CurrentACPower": "283cde80-4524-4400-a8f1-8fcf32affd72",
        "EMeter_Autarkiegrad": "a97d8833-7536-4cd4-ac88-eb43429d2e0f",
        "EMeter_Eigenverbrauchsquote": "ee821e05-d9f0-4b8a-9907-e4d83e297c65"
    },
    datapointsInt: {
        "BackupState": "ca23c4eb-dc0d-451e-929a-5880508017e9",

        "MK1Ist3WegeVentil": "25447684-1ff2-4d35-8c5f-919120d36c02",
        "MK2Ist3WegeVentil": "b656e4da-6d0e-4204-b6db-67270eaa5e90",
        "HP_HeatpumpState": "41258683-9b38-4065-80d2-34c9a7e6ec2c",

        "HPxyz_AktuelleSchritteEEV": "2bd07e02-715f-47c5-b7e5-86cb0ea41538",

        "KWL_Lüftungsstufe": "e09ac1f4-ef7e-4cb6-9312-78080b52630f",
        "KWL_CO2_Gehalt": "9a104f28-2bb5-464d-9f7b-8f03523894eb",

        "FunctionalHeatingHeatingDays": "e25d5dfd-287d-4c73-b861-2e8df3fc4705",
        "FunctionalHeatingRuns": "cc4735d9-715d-4c54-aca7-0e1a41e80066",
        "FunctionalHeatingSettings": "41471467-4174-4e6c-9669-9b6b506d1551",

        "ControlKermiMK1": "683ed933-d27e-4c87-90a7-5549ffba869f",
        "ControlKermiMK2": "9b2df2ee-09e4-45ee-a93e-b99449779928",
        "ControlKermiMK3": "bad65805-1d09-42d5-b00d-0abce6019bef",

        "HP_BufferSystem": "7a80fe50-7fb2-4de8-8e67-2002b887c10f",
        "HP_Link_Pufferspeichertyp": "d936c162-6c71-48be-885b-4ca7be164f07",
        "HP_HeatpumpType": "7ecfd672-0dab-4d7b-add0-15b45c831236",
        "HP_CoolingType": "0ed1da37-48a4-47e6-8102-70496177fc57",

        "HP_UsageExternalHeater1": "be315444-bcca-4580-8bb4-17e2c61a021b",
        "HP_Link_UsageExternalHeater1": "3cb6fba2-f5b4-489b-a7b3-b559500af7b2",
        "HP_UsageExternalHeater2": "925f1bdd-9197-4e32-984d-c86fa7bd9280",
        "HP_Link_UsageExternalHeater2": "d12fe255-cdca-4044-8781-cd0671829573",
        "HP_UsageExternalHeater3": "160283e3-eec2-48d4-8d12-7c9b96ffc315",
        "HP_Link_UsageExternalHeater3": "5bc8acee-7273-46a0-82ef-5054eeb9bfa8",

        "Battery_FeneconFEMS_Ladezustand": "4449fe87-4037-4b26-8707-d05b2f5be304",
        "HP_EEV2Steps": "f2b70ebb-a65d-4921-8d5a-610924402070",
        "Aktueller_Überhitzung_Reglungsmodus": "e73d44ca-5ffe-43be-a63a-6484ffddc55e",

        "Battery_RFBattery_Ladezustand": "28c260c1-2847-4c8f-a45c-7a7a56f6a1e6"
    },
    datapointsBool: {
        "TestModePumpMK1": "4e467f91-540a-4cd7-9edf-446a1b65d717",
        "HP_Link_PumpeMK1": "70e0d022-f43f-469b-b638-51f8ab098372",
        "TestModePumpMK2": "86901a2f-2332-4591-beff-2d35bd568216",
        "HP_Link_PumpeMK2": "82eca531-0bcd-44f1-a6fa-76156da44414",
        "TestModePumpMK3": "7b039257-8352-46a0-8026-d163a6187aa1",
        "HP_Link_PumpeHK": "99410251-d043-45be-8aa5-3943b30e4fce",

        "HP_UmschaltventilHeizenTWE": "79f66cbd-dcef-4c7e-b77b-e1fa94b2107c",
        "HP_Link_UmschaltventilHeizenTWE": "8f2cedb3-6a78-44e4-9e5b-099db0ac85f8",
        "HP_Pufferladepumpe": "70e0937e-caeb-4cb6-b616-c0e5b61aaab8",
        "HP_Link_Pufferladepumpe": "62944bf6-d433-45db-bf85-cc9424b9b756",

        "TestModeAuxiliarHeatingDrinkWater": "a7c8642f-dac6-4884-b51f-306affca2f43",
        "HP_Link_ExternerWEZ1": "26b25015-728e-4c66-b381-fa35c91a7ab6",
        "TestModeAuxiliarHeating": "a12d6aa3-f563-4d64-b169-26b75d46faf2",
        "HP_Link_ExternerWEZ2": "326feeac-a680-4e2b-8fa7-6b33ededf7a6",
        "HP_3StufeHeizen": "a56836a4-5711-4299-a983-3dec65a8b398",
        "HP_Link_ExternerWEZ3": "2b6f2433-7d5d-4f67-aa8d-a93ad90c50ac",

        "HP_Link_DLE_WEZ1": "330d77d0-8e42-4b65-897b-839d78ae5520",
        "HP_Link_DLE_WEZ2": "fc1f4518-7ff0-40cb-8166-6f340be70be4",
        "HP_Link_DLE_WEZ3": "6f65197b-bccc-4267-be0a-671c3766fe48",

        "HP_General_TWE": "b721846e-db37-4d6d-b1ae-7b0eb9b6c2f1",
        "HP_EinmalTWEPanel": "2c2d38d5-ce4c-4195-9338-3081eb6987a4",

        "HP_4WegeVentil": "2828a59d-40da-4bae-8fe9-6bb77ab97ff3",

        "KWL_Gerät_EinAus": "7ac71d63-d850-41a7-af40-ee9ac442f120",
        "KWL_Auto_Modus": "201984d5-8370-4406-81a4-cbf42b2d2b05",
        "KWL_Party_Modus": "f260c097-30f4-454e-a382-dba360e92c0c",
        "KWL_Manuel_Modus": "edfc9055-16eb-4397-a2c9-6ab4baad6871",
        "KWL_Sommer_Bypassklappe_Aktiv": "b6afcb21-2880-4b60-b9c7-625e9aacf738",
        "KWL_Elektrisches_Vorheizregister_Aktiv": "a1a6f9d6-c260-4b4f-b992-b07d0a6bf7a4",

        "FunctionalHeatingActive": "715e5a34-58ef-471b-b1a7-5cdbc3fda8e0",
        "FunctionalHeatingMK1Active": "9df04e36-0e40-4f62-9d4b-1a3e4b8949b2",
        "FunctionalHeatingMK2Active": "70f60036-39bf-4240-bee1-8e82b4a1db72",
        "FunctionalHeatingHkActive": "cceb86b6-a4b1-43cc-bda3-1a37c69fffed",

        "HP_MK1Enabled": "d7e9ad72-3d42-44ab-a2e0-b696c31c3506",
        "HP_MK2Enabled": "84b2ae80-a4ed-4f76-b493-7346f05c0462",
        "HP_MK3Enabled": "efc35d63-e383-4168-8f8b-001156d114ab",

        "HP_BivFreigabeSekHeizungHeizwasser": "5eeadb25-3c03-4c80-b48d-8aefbf3716ed",
        "HP_BivFreigabeSekHeizungHeizwasser2": "3494c060-7c37-436c-89b8-d34808d88e7d",
        "FunctionalHeatingUseExternalHeaters": "fd81908c-d425-4cc4-84fa-507691c003bf",

        "HP_UmschaltventileKuehlen": "28d40b45-b02d-4887-a626-c659c92e0dbd",
        "TestModeBrunnenPumpe": "50e53264-4143-4bad-97a1-1e9c9b655dc9",
        "TestModeSolePumpe": "adacf90a-b321-4b10-a9e9-3ad7700a723a",

        "HP_Luefter": "aeb49694-30e6-4106-aeee-1c005e5c571a",
        "EEV_2nd_available": "a436a5bb-9c4a-4d12-aae8-31549d43e4b5"
    },
    datapointsCurve2d: {
        "FunctionalHeatingCurve": "a6f08c50-85aa-4609-893a-9b64c3cebef4",
        "HeatingCurve": "22b81e9a-f93d-4a68-9f28-2052db60e07f",
        "CoolingCurve": "dfdad84b-5ca3-475e-a11c-b9c3fa926797",
        "Rubin_HeatingPowerLimit": "7ff8a441-6ddf-4aa2-a0b5-bf15ab4a1cbc",
        "Rubin_CoolingPowerLimit": "1606d243-e922-416b-a244-9b679b321d65",
    },
    datapointsDateTime: {
        "FunctionalHeatingTimestamp": "cbc12e6f-001e-408f-8250-0232ee89f2a1",
        "Longitude": "0c366261-385e-42a7-aaec-cad4d388871b",
        "Latitude": "44510f8f-b6df-4fee-8252-5826b941ebf4",
        "Place": "1432f73c-cc13-463f-a0c7-a03f4b18729a",
        "Sunrise": "3dd5e57b-2832-4903-b007-e55f6e681c8d",
        "Sunset": "81fff749-56a1-4f83-8022-a6140058a616",
        "HeatpumpStateLastChanged": "965d09ef-88db-4d10-91cd-bbe8d713bf38"
    },
    datapointsString: {
        "MK1Name": "00157e5a-e108-40fa-ba5a-85c95f0dc6af",
        "MK2Name": "37a85c10-a7d9-4e7d-8a2c-3dc35887f56a",
        "MK3Name": "63fce758-3d86-46fa-a419-1e9954854c87",

        "System_SoftwareUpdateInfo": "a32c3a02-704b-46b0-bac3-7d54202646d1"
    },
    systemDatapoints: {
        "ChangeLanguage": "df87a5cd-756e-470b-9919-02a440e42f3d",
        "InitiateUpdate": "0c4e9f8a-d0b7-4474-86f8-77a1adb0889d"
    }
}).

// Well Known Vars
constant('conf_wellKnownObjects', conf_wellKnownObjects).

constant('debugObject',[
    {
        "TimeStampUtc": "2016-12-01T00:00:00Z",
        "Value": {
            "$type": "BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared",
            "Value": 0,
            "DatapointConfigId": "7819566d-b907-489e-9376-d412eed7f643",
            "DeviceId": "a2306d32-08f0-4b2c-9b1b-807c52bade7e",
            "Flags": 0
        },
        "ConfigVersion": 0
    },
    {
        "TimeStampUtc": "2017-01-01T00:00:00Z",
        "Value": {
            "$type": "BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared",
            "Value": 184.452225,
            "DatapointConfigId": "7819566d-b907-489e-9376-d412eed7f643",
            "DeviceId": "a2306d32-08f0-4b2c-9b1b-807c52bade7e",
            "Flags": 0
        },
        "ConfigVersion": 0
    },
    {
        "TimeStampUtc": "2017-02-01T00:00:00Z",
        "Value": {
            "$type": "BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared",
            "Value": -1214145.38,
            "DatapointConfigId": "7819566d-b907-489e-9376-d412eed7f643",
            "DeviceId": "a2306d32-08f0-4b2c-9b1b-807c52bade7e",
            "Flags": 0
        },
        "ConfigVersion": 0
    },
    {
        "TimeStampUtc": "2017-03-01T00:00:00Z",
        "Value": {
            "$type": "BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared",
            "Value": 123.812309,
            "DatapointConfigId": "7819566d-b907-489e-9376-d412eed7f643",
            "DeviceId": "a2306d32-08f0-4b2c-9b1b-807c52bade7e",
            "Flags": 0
        },
        "ConfigVersion": 0
    },
    {
        "TimeStampUtc": "2017-04-01T00:00:00Z",
        "Value": {
            "$type": "BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared",
            "Value": "NaN",
            "DatapointConfigId": "7819566d-b907-489e-9376-d412eed7f643",
            "DeviceId": "a2306d32-08f0-4b2c-9b1b-807c52bade7e",
            "Flags": 0
        },
        "ConfigVersion": 0
    }
]);
